import React, { ChangeEvent, useContext, useState } from 'react';
import { AppContext } from '../../../../common/context/';
import { Modal } from '../BaseModal';
import { AssociateBusinessUnitsProps } from './AssociateBusinessUnits.Props';
import { SearchField } from '../../search-field/SearchField';

export const AssociateBusinessUnits = ({
    employee,
    endDate,
    isOpen,
    startDate,
    onClose,
    onSubmit,
}: AssociateBusinessUnitsProps) => {
    const { langResources, businessUnitsList } = useContext(AppContext);

    const [businessUnitActive, setBusinessUnitActive] = useState<number>(-1);
    const [businessUnitsListCopy, setBusinessUnitsListCopy] = useState([
        ...businessUnitsList,
    ]);
    const [searchTerm, setSearchTerm] = useState('');

    const hanlderSubmit = () => {
        onSubmit(startDate, endDate, employee, businessUnitActive);
    };

    const handlerClose = () => {
        onClose(false);
    };

    const handlerChangeBusinessUnit = (businessUnitId: number) => {
        setBusinessUnitActive(businessUnitId);
    };

    const handlerChangeTypeWorkshift = (e: ChangeEvent<HTMLInputElement>) => {
        let term = e.target.value;

        setSearchTerm(term);

        const filterList = businessUnitsList?.filter((w) =>
            w.name.toLowerCase().includes(term.toLowerCase())
        );

        setBusinessUnitsListCopy(filterList);
    };

    const handleResetSearchTerm = () => {
        setSearchTerm('');
        setBusinessUnitsListCopy(businessUnitsList);
    };

    return (
        <>
            {businessUnitsList.length > 0 && (
                <Modal
                    isOpen={isOpen}
                    modalTitle={
                        langResources['assigned.business.units.modal']['title']
                    }
                    onClose={handlerClose}
                    onSubmit={hanlderSubmit}
                    disableSubmit={businessUnitActive === -1}
                    widthCustom='800px'
                >
                    <div className='modal-body text-black '>
                        <SearchField
                            selectItemId={handlerChangeTypeWorkshift}
                            inputPlaceholder={'Buscar'}
                            labelTitle={''}
                            searchTerm={searchTerm}
                            handleResetSearchTerm={handleResetSearchTerm}
                            dataListId=''
                        />
                        <div
                            className='row '
                            style={{ maxHeight: '50vh', overflowY: 'scroll' }}
                        >
                            <table className='table  w-100 text-dark text-center'>
                                <thead
                                    className=' text-black w-100 text-center position-sticky p-0 m-0'
                                    style={{ top: '0px', background: '#fff' }}
                                >
                                    <tr>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.business.units.modal'
                                                ]['id']
                                            }
                                        </th>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.business.units.modal'
                                                ]['name']
                                            }
                                        </th>
                                        <th className='fw-bold'>
                                            {
                                                langResources[
                                                    'assigned.business.units.modal'
                                                ]['company']
                                            }
                                        </th>
                                    </tr>
                                </thead>

                                <tbody className='text-center'>
                                    {businessUnitsListCopy.map((bu) => (
                                        <tr
                                            className={`text-selected ${
                                                businessUnitActive === bu.id &&
                                                'text-selected--active'
                                            }`}
                                            key={bu.id}
                                            onClick={(e) =>
                                                handlerChangeBusinessUnit(bu.id)
                                            }
                                        >
                                            <th className='p-2'>{bu.id}</th>
                                            <th className='p-2'>{bu.name}</th>
                                            <th className='p-2'>
                                                {bu.externalCompany}
                                            </th>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};
